import { createRouter, createWebHashHistory } from "vue-router";
import routes from "./routeList";

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
